/* tslint:disable:jsx-no-lambda */
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import React, { FunctionComponent, SyntheticEvent } from 'react'
import { Dropdown } from 'semantic-ui-react'
import './styles.scss'

export interface IDropdown {
  currentValue: string | undefined
  options: { text: string; value: string | undefined }[]
  changeHandler: (value: string | undefined, event?: SyntheticEvent) => void
}

export const DesktopDropdown: FunctionComponent<IDropdown> = ({
  currentValue,
  options,
  changeHandler
}: IDropdown) => (
  <Dropdown
    scrolling={true}
    selection={true}
    fluid={true}
    clearable={true}
    value={currentValue || ''}
    onChange={(e, { value }) => changeHandler(value as string, e)}
    options={options}
    placeholder={'Keine Auswahl'}
  />
)

export const MobileDropdown: FunctionComponent<IDropdown> = ({
  currentValue,
  options,
  changeHandler
}: IDropdown) => {
  options.push({ text: 'Auswählen …', value: '' })

  return (
    <select
      onChange={e => changeHandler(e.currentTarget.value, e)}
      value={currentValue || ''}
    >
      {options.map(option => (
        <option key={option.text} value={option.value}>
          {option.text}
        </option>
      ))}
    </select>
  )
}
